// Only run on client side
const session = reactive(
  typeof window !== 'undefined'
    ? useStorageDecoder(
        globalThis.sessionStorage?.getItem('outspot-session') ?? '',
      )
    : {},
)

// Only set up watcher on client side
if (typeof window !== 'undefined') {
  watch(
    session,
    () =>
      globalThis.sessionStorage?.setItem(
        'outspot-session',
        useStorageEncoder(session),
      ),
    {
      deep: true,
    },
  )
}

export function clearSessionStorage(): void {
  if (typeof window !== 'undefined') {
    const keysToKeep = ['source']

    const valuesToKeep: any = {}

    keysToKeep.forEach((key) => {
      if (session[key]) {
        valuesToKeep[key] = session[key]
      }
    })

    globalThis.sessionStorage?.setItem(
      'outspot-session',
      useStorageEncoder(valuesToKeep),
    )
  }
}

export default () => session
